import logger from './log';

const log = logger('Error');
/**
 * Creates a new instance of a PaymentError (an extension of Error).
 * If err if is already a PaymentError - then it is simply returned
 * @param {Array.<String>|String|PaymentError=} err - The error from which to pull the error messages
 *
 * @returns {PaymentError} error
 * @returns {Array.<String>} error.errorMessages - Messages that help debug the error that should likely be NOT shown to the user
 * @returns {Boolean} error.isPaymentError - Flag to indicate that this is a payment error
 */
export const PaymentError = (err) => {
  if (_.get(err, 'isPaymentError')) return err;
  let errorMessages = [];
  if (_.isArray(err)) errorMessages = err;
  if (_.isString(err)) errorMessages = [err];
  const error = new Error(_.first(errorMessages));
  error.isPaymentError = true;
  error.errorMessages = errorMessages;
  log('New PaymentError', { err, error });
  return error;
};

/**
 * UserPaymentError
 *
 * Creates a new instance of a PaymentError (an extension of Error) that additionally includes user facing error messages.
 * If err if is already a PaymentError - then it is simply returned.
 *
 * @param {Array.<String>|String|PaymentError=} err - The error from which to pull the error messages
 *
 * @returns {PaymentError} error
 * @returns {Array.<String>} error.errorMessages - Messages that help debug the error that should likely be NOT shown to the user
 * @returns {Array.<String>} error.userMessages - Messages that can / should be shown to the user
 * @returns {Boolean} error.isPaymentError - Flag to indicate that this is a payment error
 */
export const UserPaymentError = (err, status) => {
  const error = new PaymentError(err, true);
  error.userMessages = error.errorMessages;
  if (status) {
    error.errorStatus = status;
  }
  log('New UserPaymentError', { err, error });
  return error;
};

export default PaymentError;
